export function parseDescription(description: string): string {
  if (!description) return '';

  return description
    // Remove citation links
    .replace(/\(Citation:[^)]+\)/g, '')
    // Remove MITRE ATT&CK links while keeping the text
    .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
    // Remove campaign links
    .replace(/\[[^\]]+\]\([^)]+\/campaigns\/[^)]+\)/g, '')
    // Remove sup tags and their content
    .replace(/<sup>[^<]+<\/sup>/g, '')
    // Clean up any double spaces
    .replace(/\s+/g, ' ')
    // Clean up any trailing/leading spaces
    .trim();
}